import { createFileRoute } from "@tanstack/react-router";
import { EnvPreset } from "gfx/EnvPreset";
import { envPresetSceneLights } from "gfx/sceneLights";
import withCustomizer from "lib/state/withCustomizer";
import { addBuildingGLTFTestGeometry, BUILDING_GLTF_TEST_KEYS } from "test/util/buildingGLTFTestUtil";
import { BUILDING_RENDERER_TEST_CAMERA_SETTINGS } from "test/util/buildingRendererTestUtil";
import { HeadlessRenderTestPage } from "test/util/HeadlessRenderTestPage";
import withAuthentication from "../../components/withAuthentication";

function BuildingGLTFPage() {
  const options = {
    gui: false,
    ssfxRenderer: true,
    animate: true,
    sceneLights: envPresetSceneLights[EnvPreset.WHITEBOX],
    debugFeaturesEnabled: false,
    cameraSettings: BUILDING_RENDERER_TEST_CAMERA_SETTINGS,
    useMSAA: false,
  };

  return (
    <HeadlessRenderTestPage
      testName="Building GLTF Round-Trip"
      options={options}
      testKeys={BUILDING_GLTF_TEST_KEYS}
      addGeometry={addBuildingGLTFTestGeometry}
    />
  );
}

export const Route = createFileRoute("/debug/building-gltf")({
  component: withAuthentication(withCustomizer(BuildingGLTFPage), { superAdmin: true }),
});
